import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileItem } from '@models/file-item.model';
import { PurchaseOrderDto } from '@app/models/purchase-order.model.dto';
import { CompanyService } from '@services/company.service';
import { FileService } from '@services/file.service';
import { AppPurchaseOrderService } from '@services/purchase-order.service';
import { SweetAlertService } from '@services/sweet-alert.service';
import { Toaster } from '@services/toaster.service';
import CONFIG from 'app/app.config';
import { LocalStorage } from 'ngx-webstorage';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { environment } from '@env/environment';

@Component({
  selector: 'ngx-files-step',
  templateUrl: './files-step.component.html',
  styleUrls: ['./files-step.component.scss'],
})
export class FilesStepComponent implements OnInit {
  isRCDSS = environment.name === 'rcdss';
  @LocalStorage() organizationId;

  @Input() purchaseOrder: PurchaseOrderDto;
  @Input() poFiles: FileItem[] = [];
  @Input() isSimpleFlow: boolean;
  @Output() poFilesChange: EventEmitter<FileItem[]> = new EventEmitter<FileItem[]>();
  @Output() saveDraft: EventEmitter<void> = new EventEmitter<void>();
  @Output() discard: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private $toaster: Toaster,
    private sweetAlertService: SweetAlertService,
    private fileService: FileService,
    private purchaseOrderService: AppPurchaseOrderService,
    private location: Location,
    private companyService: CompanyService,
  ) {
  }

  ngOnInit() {
  }

  addFiles($event: any) {

    const files = Object.values($event.target.files).filter((file: File) => {
      if (file.size > CONFIG.FILE_LIMIT) {
        this.$toaster.show('warning', 'File size', 'Maximum file size for uploads is 10 mb');
        return false;
      }
      return file;
    });

    this.saveFiles(files);
  }

  setAsMainFile(file: FileItem) {
    this.purchaseOrderService.setPoMainFile(file.file_id)
      .subscribe(() => {
        this.getFiles();
      });
  }

  removeFile(file: FileItem, $index) {
    this.sweetAlertService.deleteConfirmation().then((result) => {
      if (result.value) {
        this.companyService.removeFileFromPO(this.organizationId, this.purchaseOrder.id, file.file_id).subscribe(() => {
          this.poFiles.splice($index, 1);
        });
      }
    });
  }

  viewFile(file: FileItem) {
    this.companyService.getPoFileById(this.organizationId, this.purchaseOrder.id, file.file_id)
      .subscribe((blobFile) => {
        if (file.file_name.includes('.pdf')) {
          this.viewPdf(file, blobFile);
        } else {
          this.viewImage(file, blobFile);
        }
      });
  }

  viewPdf(taskFile: FileItem, blobFile: Blob) {
    this.fileService.viewPdf(blobFile, taskFile.file_name);
  }

  viewImage(taskFile: FileItem, blobFile: Blob) {
    this.fileService.viewImage(blobFile, taskFile.file_name);
  }

  goBack() {
    this.location.back();
  }

  saveFiles(files) {
    if (this.purchaseOrder && this.purchaseOrder.id) {
      const filesObservable = [];

      files.forEach((file, index) => {
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        const isMain = index === 0 && !this.poFiles.length;
        const fileObservable = this.companyService
          .addFileToPo(this.organizationId, this.purchaseOrder.id, formData, isMain);
        filesObservable.push(fileObservable);
      });
      forkJoin(...filesObservable).subscribe(() => {
        this.getFiles();
      });
    }
  }

  getFiles() {
    if (!this.purchaseOrder || !this.purchaseOrder.id) {
      return;
    }
    this.companyService.getPoFiles(this.purchaseOrder.id).subscribe((files) => {
      this.poFiles = files.sort((currentFile: FileItem, nextFile: FileItem) => {
        return currentFile.is_main_file ? -1 : 1;
      });
      this.poFilesChange.emit(this.poFiles);
    });
  }
}
